import React from 'react';
import styled from 'styled-components';

import { PageTitle, PageWrapper } from '../../components/pageComponents';
import { JoinUs } from '../../components';
import { SuppliersForm } from '../../containers';
import theme from '../../styles/theme';

const GrayLine = styled.div`
  background-color: ${theme.colors.grey2};
  height: 1px;
  width: 85%;
  margin-top: 1.5em;
  margin-bottom: 1.5em;
`;

const JoinWrapper = styled.div`
  width: 85%;
  min-height: 280px;
`;

const PageSubtitle = styled.p`
  font-weight: bold;
  margin-bottom: 2em;
`;

const StyledPageTitle = styled(PageTitle)`
  margin: 0;
`;

const JoinUsPage = () => {
  return (
    <PageWrapper>
      <StyledPageTitle>FAÇA PARTE</StyledPageTitle>
      <PageSubtitle>FORNECEDOR</PageSubtitle>
      <SuppliersForm />
      <GrayLine />
      <JoinWrapper>
        <JoinUs />
      </JoinWrapper>
    </PageWrapper>
  );
};

export default JoinUsPage;
